module.exports = __webpack_public_path__ + "img/pleisure_bodyimage05-3.3e962bcb.jpg";